import { render, staticRenderFns } from "./TeacherStats.vue?vue&type=template&id=445f37b7&"
import script from "./TeacherStats.vue?vue&type=script&lang=js&"
export * from "./TeacherStats.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports